import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import history from 'configureHistory'
import classNames from 'classnames'

import { Icon, Button } from 'components'

import './pageOverlay.scss'

class PageOverlay extends Component {
	componentDidMount() {
		window.addEventListener('keydown', this.onKeyDown, true)
	}

	componentWillUnmount() {
		window.removeEventListener('keydown', this.onKeyDown, true)
	}

	onKeyDown = e => {
		const { location, visible } = this.props

		if (e.keyCode === 27 && visible) {
			const openModal = document.querySelector('.c-modal')

			if (openModal === null) {
				this.onClose()
				history.push(location.pathname)
			}
		}
	}

	onClose = () => {
		const { onClose } = this.props

		if (onClose) {
			onClose()
		}
	}

	render() {
		const {
			children,
			header,
			headerBorder,
			visible,
			contentWidth,
			noHorizontalSpacing,
		} = this.props

		if (visible === false) {
			return null
		}

		return ReactDOM.createPortal(
			<div className="c-page-overlay">
				<div
					className={classNames(
						'c-page-overlay__header',
						headerBorder && 'c-page-overlay__header--bordered'
					)}
				>
					<div className="c-page-overlay__header-inner">
						{header && (
							<div className="c-page-overlay__header-content">
								{header}
							</div>
						)}
					</div>

					<div className="c-page-overlay__close">
						<Button
							onClick={() => {
								this.onClose()

								history.push({ hash: '' })
							}}
							centerContent
							icon={<Icon name="close" />}
						/>
					</div>
				</div>

				<div
					className={classNames(
						'c-page-overlay__content',
						`c-page-overlay__content--${contentWidth}`,
						{
							'c-page-overlay__content--no-horizontal-spacing': noHorizontalSpacing,
						}
					)}
				>
					{children}
				</div>
			</div>,
			document.getElementById('root')
		)
	}
}

PageOverlay.propTypes = {
	header: PropTypes.node,
	headerBorder: PropTypes.bool,
	children: PropTypes.node.isRequired,
	visible: PropTypes.bool,
	location: PropTypes.shape().isRequired,
	onClose: PropTypes.func,
	contentWidth: PropTypes.oneOf(['default', 'wide']),
	noHorizontalSpacing: PropTypes.bool,
}

PageOverlay.defaultProps = {
	header: null,
	headerBorder: false,
	visible: true,
	onClose: null,
	contentWidth: 'default',
	noHorizontalSpacing: false,
}

export default PageOverlay
